import { UniqueIdentifier } from '@dnd-kit/core';
import { createContext, useContext } from 'react';
import { Entity } from '@shared/data/entity/Entity';

export interface ActiveCard {
  id: string;
  groupId: UniqueIdentifier;
  entity: Entity;
  workflowEntity: MBAPI.WorkflowEntity;
  nextEntity?: MBAPI.WorkflowEntity;
  prevEntity?: MBAPI.WorkflowEntity;
}

export interface DraggableContextValue {
  isDragEnabled: boolean;
  isDragSortEnabled: boolean;
  isDragging: boolean;
  activeCards: ActiveCard[];
  activeGroupId?: UniqueIdentifier;
}

export const DraggableContext = createContext<DraggableContextValue>({
  isDragEnabled: false,
  isDragSortEnabled: false,
  isDragging: false,
  activeCards: [],
});

export function useDraggableContext() {
  return useContext(DraggableContext);
}
